export default __webpack_public_path__ + "b0be2858bd1af3e542c9bc3156eef124.svg";